export enum ErrorType {
  SESSION_TIMEOUT = "1000",
  NOT_AUTHORIZED = "1001",
  UPDATE_FAIL = "1002",
  EXCEEDS_UPPER_LIMIT_OF_BETTING_RECORDS = "1003",
  SYSTEM_MAINTENANCE = "1004",
  INSUFFICIENT_PARAMETER = "1005",
  CASINO_MAINTENANCE = "1006",
  IP_BLOCK = "1007",
  DISABLED_FRONTEND_BACKEDN_SEPARATION = "1008",
  USER_IS_NULL = "3003",
  FAIL = "9999"
}

interface ErrorInfo {
  status: ErrorType
  message?: string
  pageName?: string
  excludeFromSentry?: boolean
}

export const errorTypeConst: Record<keyof typeof ErrorType, ErrorInfo> = Object.freeze({
  SESSION_TIMEOUT: {
    status: ErrorType.SESSION_TIMEOUT,
    message: "Not Authorized",
    excludeFromSentry: true
  },
  USER_IS_NULL: {
    status: ErrorType.USER_IS_NULL,
    message: "Not Authorized",
    excludeFromSentry: true
  },
  NOT_AUTHORIZED: {
    status: ErrorType.NOT_AUTHORIZED,
    message: "Not Authorized",
    excludeFromSentry: true
  },
  UPDATE_FAIL: {
    status: ErrorType.UPDATE_FAIL,
    message: "Update Fail"
  },
  EXCEEDS_UPPER_LIMIT_OF_BETTING_RECORDS: {
    status: ErrorType.EXCEEDS_UPPER_LIMIT_OF_BETTING_RECORDS,
    message: "Exceeds the upper limit of Betting records",
    excludeFromSentry: true
  },
  SYSTEM_MAINTENANCE: {
    status: ErrorType.SYSTEM_MAINTENANCE,
    pageName: "SystemMaintenance",
    message: "System is under Maintenance",
    excludeFromSentry: true
  },
  INSUFFICIENT_PARAMETER: {
    status: ErrorType.INSUFFICIENT_PARAMETER,
    message: "Insufficient Parameters"
  },
  CASINO_MAINTENANCE: {
    status: ErrorType.CASINO_MAINTENANCE,
    pageName: "CasinoMaintenance",
    message: "Vendor is under Maintenance",
    excludeFromSentry: true
  },
  DISABLED_FRONTEND_BACKEDN_SEPARATION: {
    status: ErrorType.DISABLED_FRONTEND_BACKEDN_SEPARATION,
    message: "Disabled Frontend Backend Separation",
    excludeFromSentry: true
  },
  IP_BLOCK: {
    status: ErrorType.IP_BLOCK,
    pageName: "IPBlock",
    message: "User IP Being Block",
    excludeFromSentry: true
  },
  FAIL: {
    status: ErrorType.FAIL
  }
})

export default errorTypeConst
